import { Component } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';
import { checkBrowserLanguage, defaultLanguageKey, LanguageKey } from 'src/app/shared/models/language.dto';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'vee-language-select-dialog',
  templateUrl: './language-select-dialog.component.html',
  styleUrls: ['./language-select-dialog.component.scss'],
  standalone: false,
})
export class LanguageSelectDialogComponent {
public newPassword?: string;
public selectedLanguage: LanguageKey = defaultLanguageKey;
  constructor(
    public dialogService: DialogService,
    public translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  onChangeLanguage(lang: LanguageKey) {
    this.translate.use(checkBrowserLanguage(lang));

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { lang },
      queryParamsHandling: 'merge',
    });
    
  }
}
